import 'script-loader!fontfaceobserver';
import 'script-loader!promise-polyfill';
import 'script-loader!../fonts-load';
